import { ComponentPropsToStylePropsMap, withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { API } from 'aws-amplify';
import React, { useState, useEffect } from 'react';
import { createBrowserRouter , Route, createRoutesFromElements, RouterProvider, Navigate } from 'react-router-dom';
import { PubSub } from 'aws-amplify'
import SwitchPoint from './components/Uswitch/switchpoint'
//import Switches from './components/SwitchPanel/switchpanel';
import SwitchPanel from './components/SwitchPanel/switchpanel'

//import {About} from './components/About/about';
import About from './components/About/about';
import SharedLayout from './components/SharedLayout/sharedlayout';
import CloudId from './components/CloudId/cloudid'
import Admin from './components/Admin/admin';
import Joiner from './components/Joiner/joiner';
import Dashboard from './components/Dashboard/dashboard';
import {Settings, settingsLoader}  from './components/Settings/settings';
import Home from './components/Home/home';
//import { Invite, invitesLoader}  from './components/Invite/invite';
//import { Invite, invitesLoader}  from './components/Invite/invite';
import { Users, usersLoader } from './components/Users/users';
import Uswitch from './components/Uswitch/uswitch';
import Monitor from './components/Monitor/monitor';
import Rack from './components/Rack/rack'

function NoMatch() {
  return (
    <div style={{ padding: 20 }}>
      <h2>404: Page Not Found</h2>
      <p>No url match occured.</p>
    </div>
  );
}

const ProtectedRoute = ({ user, children }) => {
  if (!user) {
    return <Navigate to="/" replace />;
  }
  return children;
};

function initialGetter(thinglist) {
          //Now get all the latest io and configs
          console.log('starting initialGetter');
          var topic_list = [];
          thinglist.forEach( thisThing => {
            var thingName = thisThing.thingName;
            if (thingName === "4091511c44dd") {
              var topic = "$aws/things/" + thingName + "/shadow/name/config/get";
              console.log('startup config to get ', topic);
              topic_list.push(topic);
              topic = "$aws/things/" + thingName + "/shadow/name/io/get";
              console.log('startup config to get ', topic);
              topic_list.push(topic);            
            }        
          });
          console.log('refreshing these topics:', topic_list);
          var empty_message = "";
          PubSub.publish(topic_list,empty_message);  
          console.log('initialGetter complete');
          
};

function App({ signOut, user }) {


  const typicalx = {"4091511c44dd":{"Relays":[{"index":0,"state":1},{"index":1,"state":1}],"GPIOs":[{"index":0,"state":1},{"index":1,"state":0}],"Adcs":[]},
                 "4091511c51cd":{"Relays":[{"index":0,"state":1},{"index":1,"state":1}],"GPIOs":[{"index":0,"state":1},{"index":1,"state":0}],"Adcs":[]}}

  const typical0 =  [
    {
      id: 1,
      mac: '4091511c44dd',
      name: 'SwitchOne',
      sensors: {
      Relays: [
        { index: 0, state: 0 },
        { index: 1, state: 0 }
      ],
      GPIOs: [
        { index: 0, state: 0 },
        { index: 1, state: 0 }
      ]
      }
    }
    ,
    {
      id: 2,
      mac: '4091511c51cd',
      name: 'SwitchTwo',
      sensors: {
        Relays: [
          { index: 0, state: 1 },
          { index: 1, state: 1 }
        ],
        GPIOs: [
          { index: 0, state: 1 },
          { index: 1, state: 1 }
        ]
      }
    }
]

const typical =  [
  {
    id: 1,
    mac: '4091511c44dd',
    name: 'SwitchOne',
    sensors:''
  }
,
]
  const [isLoading, setisLoading] = useState(0);
  const [userLandscape, setUserLandscape] = useState({});
  const [topicLogging, setTopicLogging] = useState([]);
  const [switchIO, setSwitchIO] = useState(typical);
  const [switchConfig, setSwitchConfig] = useState({});


  console.log('App entry');
  const useradmin = true;
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<SharedLayout props={{ucs:userLandscape, signout:signOut}} />}>
        <Route 
          path="settings" 
          element={<Settings  ucs={userLandscape} />} 
          loader={settingsLoader}
        />
        <Route path="about" element={<About />} />     
        <Route path="admin">
          <Route
            index
            element={
              <ProtectedRoute user={useradmin}>
                {" "}
                <Admin ucs={userLandscape} />
              </ProtectedRoute>
            }
          />
          <Route
            path="joiner"
            element={
              <ProtectedRoute user={useradmin}>
                <Joiner ucs={userLandscape} />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route index path="switches" element={<SwitchPanel switch_info={{ucs:userLandscape}} /> } /> 
        <Route
          path="dashboard"
          element={<Dashboard userLandscape={userLandscape} />}
        />
        <Route
          path="monitor"
          element={<Monitor monitorData={switchIO} />}
        />

        <Route
          path="rack"
          element={<Rack switch_now={{ucs:userLandscape}} />}
        />

        <Route
          path="uswitch"
          element={<Uswitch  switchInfo={{ userLandscape }} />}
        />
        <Route path="*" element={<NoMatch />} />
      </Route>
    )
  );



  const updateDeviceSensors = (deviceMAC, newDocument) => {
    console.log('XXXXX updating sensor',deviceMAC,newDocument);
    //var newSensor = JSON.parse(newAge);
    //var newObject = documentSerializer(newDocument);
    //console.log('XXX Document Objectified Inserted', newDocument);
    //if deviceId not in deviceSensors.keys():
    var asString = JSON.stringify(newDocument);
    var newSwitchIO = [...switchIO];
    setSwitchIO([newSwitchIO.map(device =>
      device.mac === deviceMAC ? { 
        ...device, sensors: asString
      } 
      : device
    )]);
    console.log('da da data now', switchIO);


  /*
    
    var newSetting = switchIO.map(device =>
      device.mac === deviceMAC ? {...device, sensors: newDocument} : device
    );
    console.log("NEW TO WRITE", newSetting);
    setSwitchIO(newSetting);
    setSwitchIO([...switchIO,])
    */

   }; 


  useEffect(() => {
    const loadUserLandscape = async () => {
      setisLoading(1);
      const databack = await getUserLandscape();
      setisLoading(2);
      setUserLandscape(databack.data);
      console.log("App UseEffect:userLandscape now set", databack.data);
      var thinglist = databack.data.allthings;

      var subscribe_list = []
      thinglist.forEach( thisThing => {
        var thingName = thisThing.thingName;
        if (thingName === "4091511c44dd" || thingName === "4091511c51cd") {
          var topic = "$aws/things/" + thingName + "/shadow/name/io/update/documents";
          subscribe_list.push(topic);
          topic = "$aws/things/" + thingName + "/shadow/name/io/get/accepted";
          subscribe_list.push(topic);
          // SUBSCRIBE TO THE CONFIGS
          topic = "$aws/things/" + thingName + "/shadow/name/config/update/documents";
          subscribe_list.push(topic);
          topic = "$aws/things/" + thingName + "/shadow/name/config/get/accepted";
          subscribe_list.push(topic);
        }
      });


        //const subscriptionReactListener = PubSub.subscribe(subscribe_topic).subscribe({
        

        /*
        PubSub.subscribe(subscribe_list).subscribe({
        //PubSub.subscribe({ topics: subscribe_topic_list }).subscribe({
        //PubSub.subscribe({ topics: ['$aws/things/4091511c44dd/shadow/get', '$aws/things/4091511c44dd/shadow/get/accepted'] }).subscribe({
          next: (data) => {
              console.log('>>>>>>>>>>>>> MQTT data in')
              const objectSymbols = Object.getOwnPropertySymbols(data.value);
              var message_topic = data.value[objectSymbols[0]];
              var topic_path= message_topic.split("/");
              var topic_channel = topic_path.slice(5)[0]; // io|config
              //var topic_action = topic_path.slice[6][0]; // get|update 
              var message_key = topic_path.slice(-1)[0];
              var message_device = topic_path.slice(2)[0]; //4091511c44dd
              console.log('topic:', message_device, topic_channel, message_key, );
              console.log('MQTT message:', data.value);  
              if (topic_channel === "io") {
                if (message_key === "documents") {
                  //console.log('data document for device ', message_device);
                  const document = data.value.current.state.reported;
                  
                  updateDeviceSensors(message_device,JSON.stringify(document));
                  if (false) {
                  //console.log('const document now...', document);
                  var shaped = documentSerializer(document);
                  console.log('data need to set  ', shaped);
                  //var switchNowIoD = switchIO;
                  var switchNowIoD = {...switchIO, message_device:shaped};
                  console.log(':::vallue now', switchNowIoD);
                  //setState({...state})
                  switchNowIoD[message_device] = shaped;
                  setSwitchIO({...switchIO, message_device:shaped });
                  
                  console.log('showing after switchIO', JSON.stringify(switchIO));
                  console.log('showing switchconfig for convenience', JSON.stringify(switchConfig));
                  }
                } 
                else if (message_key === "accepted") {
                  console.log('processing : io accepted');
                  const document = data.value.state.reported;
                  //updateDeviceSensors(message_device,data.value.state.reported);
                  if (false) {
                  var shapeda = documentSerializer(document);
                  var switchNow = switchIO;
                  switchNow[message_device] = shapeda;
                  setSwitchIO(switchNow);
                  
                  console.log('switchIO is now', switchIO);
                }
                }
                else {
                  console.log('NOT AN IO/DOCUMENTS/ACCEPTED topic', message_key);
                }
              } 
              else if (topic_channel === "config") {

                if ( message_key === "accepted" ) {
                  // config/accepted...  from a get...
                  console.log("config channel data from an accepted", data.value);
                  var  document = data.value.state.reported;
                  //var shapedc = documentSerializer(document);
                  console.log('setting CONFIG after serial is ', document);
                  var switchConfigNow = switchConfig;
                  //switchConfigNow[message_device] = document;
                  //setSwitchConfig(switchConfigNow);
                } 

                else if (message_key === "documents") {
                  console.log('config document shows from config change')
                  document = data.value.current.state.reported;
                  //var shapedd = documentSerializer(document);
                  //console.log('setting CONFIG after shaping is ', shapedd);
                  var switchConfigNowC = switchConfig;
                  switchConfigNowC[message_device] = document;
                  setSwitchConfig(switchConfigNowC);
                }
                console.log('showing switchConfig', JSON.stringify(switchConfig));
              }
              else {
                console.log('topic channel ', topic_channel, ' not supported yet.');
              }
              console.log('MQTT data done >>>>>>>>>>>>>')
              //setTopicLogging(data);  
            },
            error: (error) => console.error(error),
            complete: () => console.log('Complete done')
        });
        */

        //setisLoading(2);
        //await new Promise(r => setTimeout(r, 2000));
        //Now get all the latest io and configs
        //initialGetter(thinglist);
       
        var topic_list = [];
        thinglist.forEach( thisThing => {
          var thingName = thisThing.thingName;
          if (thingName === "4091511c44dd" || thingName === "4091511c51cd") {
            var topic = "$aws/things/" + thingName + "/shadow/name/config/get";
            //console.log('startup config to get ', topic);
            topic_list.push(topic);
            topic = "$aws/things/" + thingName + "/shadow/name/io/get";
            //console.log('startup config to get ', topic);
            topic_list.push(topic);            
          }        
        });
        //console.log('refreshing these topics:', topic_list);
        var empty_message = "";
        //PubSub.publish(topic_list,empty_message);  
      setisLoading(0);
    }
    loadUserLandscape();  
  },[]);


  // 
       /* <Route path="switches" element={<SwitchPoint switch_info={{topic:"policy/relays/4091511c51cd", ucs:userLandscape}} /> } /> */

  async function getUserLandscape() {
    const apiName = 'apicustomers';
    const path = '/customers';
    const myInit = {
      headers: {}, // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    };
    return API.get(apiName, path, myInit);
  }

  async function globalClickHandler() {
    console.log('global click handler called');
  }
 
  return (
    <>
     {isLoading > 0 ? ( 
       isLoading>1 ? <h1> Wrapping up App Initial Loader... </h1> : <h1>Gathering your switches info.</h1>
     ) : (    
      <>     
      <RouterProvider router={router} />
      </>
    )}
  
    </>
  );
}


const hasValue = (obj, value) => Object.values(obj).includes(value);
const hasKey = (obj, key) => Object.keys(obj).includes(key);


function documentSerializer(document) {
  // a.Relays.0.color_assert": 255,
  var device = {'Relays':[], 'GPIOs':[], 'Adcs':[], 'DACs':[]};
  var stack_relays = {};
  var stack_gpios = {};
  var stack_adcs = {};

  for (const key in document) {
    var new_add = {};
    //console.log(`working on key ${key}`);
    var sensor_split = key.split(".");
    var sensor_type = sensor_split[1];
    var sensor_id = parseInt(sensor_split[2]);
    var sensor_attribute = sensor_split[3];
    var sensor_value = document[key];


    //var somex = device[sensor_type];
    //console.log('device is long', somex.len);
    // is this id already existing ?
    // test.some(function(boy) { return hasValue(boy, "age", 12); }));

    //if (e.target.getAttribute('index') === 1)
    
    //var already_exists = device.some(function(this_device) { return hasValue(this_device, "index", sensor_id)})
    //var checkone = device[sensor_type];
    //var checktwo = checkone[0];
    //var c3 = hasKey(checktwo, 'index');
    //var c4 = hasValue(checktwo.index, sensor_id);

    //console.log("Serializer:device:jsonString:",JSON.stringify(device));
    var does_index_exist = device[sensor_type].some(function (item, index) {
      //console.log('considering self.inspection', item, sensor_id);
      //console.log('exist in device',JSON.stringify(device));
      var has_index = hasKey(item, 'index');
      var has_value = item['index'] === sensor_id;
      //var has_value2 = hasValue(item, sensor_id);
      if (has_index && has_value) {
        //console.log('index found!');
        return true;
      }
      //console.log('NOT FOUND');
      return false;
    });


    //console.log('bilder vars',does_index_exist, sensor_type, sensor_id, sensor_attribute, sensor_value);

    if (!does_index_exist) {
      device[sensor_type].push({index:sensor_id})
    }

    var sensor_target = device[sensor_type][sensor_id];


    //var isit = device[sensor_type][0].getAttribute('index');
    //var already_exists = device.some(function(this_device) { return this_device.getAttribute('index') === 0 })

    //var already_exists = Object.hasOwn(device[sensor_type]['index'], 'prop'));

    device[sensor_type][sensor_id][sensor_attribute] = sensor_value;
    //sensor_target[sensor_attribute] = sensor_value;



}
return device;
}

export default withAuthenticator(App);